import React from 'react';
import Web3AIChat from './components/Web3AIChat';

function App() {
  return (
    <div className="App">
      <Web3AIChat />
    </div>
  );
}

export default App;